<template>
    <div class="screen-title-container" v-if="text || showAvatars">
        <div class="screen-title">
            <div class="screen-title-text" v-if="text" v-html="text">
            </div>

            <div class="screen-title-avatars-container" v-if="showAvatars">

                <template v-for="(playerAvatar, playerAvatarId) of players">
                    <div v-bind:key="'screen-title-avatar' + playerAvatarId + playerAvatar.isTurn">
                        <AvatarCircle v-if="playerAvatar.isTurn == false" class="avatar-circle-small" :size="33"
                            :sizeInner="24" :id="playerAvatar.id"></AvatarCircle>
                        <AvatarCircle v-if="playerAvatar.isTurn" :showRibbon="true" class="avatar-circle-large"
                            :size="64" :sizeInner="47" :id="playerAvatar.id">
                        </AvatarCircle>
                    </div>
                </template>

            </div>

        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import AvatarCircle from './AvatarCircle.vue';
import Game, { currentPlayer } from '../../../shared_fca/game';

interface playerData {
    id: string;
    isTurn: boolean;
}

export default Vue.extend({
    name: 'ScreenTitle',
    components: {
        AvatarCircle
    },
    props: {
        text: String,
        showAvatars: Boolean,
        user: String,
        game: Object as PropType<Game>,
    },
    computed: {
        players: {
            cache: false,
            get(): playerData[] {

                const result: playerData[] = [];

                const playerState = this.game.playerStates[this.user];

                const playerRound = playerState.round;
                const keyArray = Object.keys(this.game.playerStates);

                for (let i = 0; i < keyArray.length; i++) {

                    let offset = i + playerRound;
                    while (offset >= keyArray.length) {
                        offset -= keyArray.length;
                    }

                    const playerId = keyArray[offset];
                    const isTurn = currentPlayer(this.game).toString() == playerId;
                    result.push({ id: playerId, isTurn });
                }

                return result;

            }
        }
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.screen-title-avatars-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: start;
}

.avatar-circle-large {
    margin-left: 12.5px;
    margin-right: 12.5px;
}

.avatar-circle-small {
    margin-top: 6px;
    margin-left: 6.5px;
    margin-right: 6.5px;
}

.screen-title-text {
    font-family: Rubik;
    font-size: 20px;
    font-weight: 800;
    line-height: 23.7px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    width: 100%;
    position: absolute;
    top: 11px;
    color: #636252;
}

.screen-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 0px;
    width: 100%;
    pointer-events: none;
    animation: screen-title-container-animation 1s;
}

@keyframes screen-title-container-animation {
    0% {
        top: -67px;
    }

    100% {
        top: 0px;
    }
}

.screen-title {
    background-image: url("../assets-fca/UI/screen-title.svg");
    position: absolute;
    width: 349px;
    height: 67px;
}
</style>